//   para agregar proyecto nuevo se coloca con esta sintaxis:
//   {id: 1,vURL: "assets/img/proyectos/titulo.mp4"},
//   {id: 2,vURL: "assets/img/proyectos/titulo.mp4"},

const proyectos = [
  { id: 1, vURL: "assets/img/proyectos/construcavijun2025.mp4" },
];

export default proyectos;
